/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Plugins
import { createPinia } from 'pinia'
import router from '../router'

// Types
import { i18n, i18nInstance } from '@/plugins/i18n'
import { VeeValidate } from '@/plugins/veeValidate'
import type { App } from 'vue'
import VueTelInput from 'vue-tel-input'
import 'vue-tel-input/vue-tel-input.css'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

export const pinia = createPinia()
export function registerPlugins(app: App) {
  app
    .use(router)
    .use(pinia)
    .use(i18nInstance)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .use(VueTelInput as any, { mode: 'international', autoFormat: false, defaultCountry: 'cm' })
    .use(Toast, {
      transition: 'Vue-Toastification__fade',
      maxToasts: 2,
      newestOnTop: true,
      position: 'top',
      timeout: 3000,
      closeOnClick: true,
      pauseOnFocusLoss: true,
      pauseOnHover: true,
      draggable: true,
      draggablePercent: 0.6,
      showCloseButtonOnHover: false,
      hideProgressBar: false,
      closeButton: 'button',
      icon: true,
      rtl: false,
    })
  VeeValidate.init(i18n.locale.value)
}
